import { Box, Typography } from '@mui/material'
import './index.scss'

import { useCallback, useEffect, useMemo } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import { getCreditsDetails } from '../../../axios/api/dashboard'
import { setAvailableCreditsDetails } from '../../../store/slice/auth'
import { ROLES } from '../../../utils/constant'
import { checkUserAccess, showErrorToast } from '../../../utils/utils'
import CircularProgressBar from '../../circular-progress-bar'
import Icon from '../../icon'

const AvailableCreditsBadge = () => {
  //Hooks
  const navigate = useNavigate()
  const dispatch = useDispatch()

  // Redux states
  const selectedWorkspace = useSelector(
    (state) => state.workspace.selectedWorkspace
  )
  const creditsDetails = useSelector((state) => state.auth.creditsDetails)

  // Local states
  // const [loading, setLoading] = useState(false)

  // variables
  const canPurchasePlan = useMemo(() => checkUserAccess([ROLES.ADMIN]), [])

  const navigateToBuyCredits = useCallback(() => {
    if (canPurchasePlan) {
      navigate('/subscription?active=credit')
    }
  }, [canPurchasePlan, navigate])

  // Handlers
  const fetchCreditsDetails = useCallback(async () => {
    if (!selectedWorkspace?.id) return

    // setLoading(true)
    const response = await getCreditsDetails(selectedWorkspace.id)
    // setLoading(false)
    if (response?.isError) {
      showErrorToast(response)
    } else {
      dispatch(setAvailableCreditsDetails(response))
    }
  }, [selectedWorkspace?.id, dispatch])

  // Effects
  useEffect(() => {
    fetchCreditsDetails()
  }, [fetchCreditsDetails])

  return (
    <Box
      className={`available-credits-badge ${
        canPurchasePlan ? 'purchase-access' : ''
      }`}
      id="credits-info"
    >
      <Box className="available-credits-badge-container">
        <Box className="used-credit-progress" sx={{ position: 'relative' }}>
          <CircularProgressBar size={32} value={100} thickness={5} />
          <Box className="credit-available-btn">
            <Box className="credit-coin-icon">
              <Icon icon="noto:coin" />
            </Box>
            <Box className="add-credit-icon" onClick={navigateToBuyCredits}>
              <Box className="icon-wrapper">
                <Icon icon="qlementine-icons:plus-16" />
              </Box>
            </Box>
          </Box>
        </Box>
        <Box className="credit-details">
          <Typography className="credit-count">
            {creditsDetails?.availableCredits || 0}
          </Typography>
          <Typography className="credit-description">
            credits available
          </Typography>
        </Box>
      </Box>

      {/* <Box
        className={`available-credits-badge-refresh ${
          loading ? 'loading' : ''
        }`}
        onClick={fetchCreditsDetails}
      >
        <Icon
          className="refresh-icon"
          icon="humbleicons:refresh"
          fontSize="16px"
        />
      </Box> */}
    </Box>
  )
}

export default AvailableCreditsBadge
